import React from "react";
import "./Home.css";
import Products from "../components/Products";
import logo from "../asset/Regal elegance in gold and navy.png";
import juteImg from "../asset/35187.jpg"; // 🔥 local image
import Testimonials from "../components/Testimonials";
import Gallery from "../components/Gallery";
import CTASection from "../components/CTASection";

const images = [juteImg];

const Home: React.FC = () => {
  const index = 0;

  return (
    <div>

      {/* NAVBAR */}
      <header className="navbar">
        {/* LEFT LOGO */}
        <div className="logo">
          <img src={logo} alt="Rohit Regal Venture Logo" />
          <span>Rohit Regal Venture</span>
        </div>

        {/* CENTER MENU */}
        <nav className="nav-links">
          <a href="/">Home</a>
          <a href="/about">About Us</a>
          <a href="/services">Services</a>
          <a href="/contact">Contact</a>
        </nav>

        {/* RIGHT SIDE */}
        <div className="actions">
          <div className="socials">
            <i className="fa fa-facebook"></i>
            <i className="fa fa-instagram"></i>
            <i className="fa fa-linkedin"></i>
          </div>

          <a href="tel:8826246163" className="primary-btn-nav">
            Call Now
          </a>

          <a href="/contact" className="secondary-btn-nav">
            Contact
          </a>
        </div>
      </header>

      {/* 🔥 HERO */}
      <section className="hero">

        {/* 🔥 BLUR BACKGROUND IMAGE */}
        <div
          className="hero-bg"
          style={{ backgroundImage: `url(${images[index]})` }}
        ></div>

        {/* 🔥 OVERLAY */}
        <div className="overlay"></div>

        {/* 🔥 CONTENT */}
        <div className="hero-content">
          <p className="tag fade-in">Eco-Friendly Bags</p>

          <h1 className="title slide-up">
            Durable Jute, Canvas <br />
            & Nylon Bags
          </h1>

          <p className="subtext fade-in delay">
            Straight from our New Delhi factory. Custom printing and unbeatable prices.
          </p>

          <div className="hero-badges fade-in delay2">
            <span>100% Sustainable</span>
            <span>Custom Branding</span>
            <span>Pan India Delivery</span>
          </div>

          <div className="buttons fade-in delay3">
            <a
              href="https://wa.me/918826246163"
              target="_blank"
              rel="noopener noreferrer"
              className="primary-btn"
            >
              Bulk Order
            </a>

            <a href="#about" className="secondary-btn">
              Learn More
            </a>
          </div>
        </div>

      </section>

      <Products />
      <Testimonials />
      <Gallery />
      <CTASection />

    </div>
  );
};

export default Home;